import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { isNilOrEmpty } from 'ramda-extension';

import { getLabelMessage } from '@gef-ui/localization/messages';

export const QuickFilter = ({ quickFilterState, quickFilterTypesSetup, onChange, onReset, subheaderOpen }) => {
	const handleFilterChange = useCallback(
		(type) => () => {
			if (!!onReset) {
				if (type !== quickFilterState) {
					onChange(type);
				} else {
					onReset(type);
				}
			} else {
				onChange(type);
			}
		},
		[onChange, quickFilterState, onReset],
	);

	const isTypeActive = useCallback(
		(quickFilterType) => {
			return quickFilterState === quickFilterType;
		},
		[quickFilterState],
	);

	return (
		<Stack spacing={1} direction="row">
			{!isNilOrEmpty(quickFilterTypesSetup) &&
				quickFilterTypesSetup.map((filter) => (
					<Chip
						key={filter.type}
						size="small"
						label={getLabelMessage(filter.label)}
						color={!subheaderOpen && isTypeActive(filter.type) ? 'primary' : 'default'}
						onClick={handleFilterChange(filter.type)}
					/>
				))}
		</Stack>
	);
};

QuickFilter.propTypes = {
	onChange: PropTypes.func,
	onReset: PropTypes.func,
	quickFilterState: PropTypes.string,
	quickFilterTypesSetup: PropTypes.array,
	subheaderOpen: PropTypes.bool,
};

export default QuickFilter;
